export default __webpack_public_path__ + "static/media/default-car.d52cb9e7.png";